var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRwanda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 18.7718 0.705188 21.379 1.94544 23.6521L16 25.0435L30.0546 23.6521C31.2948 21.379 32 18.7718 32 16L16 14.6086L0 16Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0546 8.34781C27.3409 3.37431 22.0647 0 16 0C9.93531 0 4.65912 3.37431 1.94544 8.34781C0.705188 10.621 0 13.2281 0 16H32C32 13.2281 31.2948 10.621 30.0546 8.34781Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 31.9999C22.0647 31.9999 27.3409 28.6256 30.0546 23.6521H1.94543C4.65912 28.6256 9.93531 31.9999 16 31.9999Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 9.36382L20.041 10.283L19.0005 12.1755L21.1224 11.7696L21.3912 13.9131L22.8691 12.3366L24.3471 13.9131L24.6159 11.7696L26.7378 12.1754L25.6973 10.2829L27.6513 9.36382L25.6972 8.44476L26.7378 6.55226L24.616 6.95813L24.347 4.8147L22.8691 6.3912L21.3912 4.8147L21.1224 6.95813L19.0004 6.55226L20.041 8.44482L18.0869 9.36382Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRwanda);
export default __webpack_public_path__ + "static/media/flag_rwanda.a7811006b831b02a20fa88ce239a9321.svg";
export { ForwardRef as ReactComponent };